import { useSelector } from "react-redux";
import { addBannerData, bannerDataSelector } from "../Redux/appStateSlice";
import { WithFetchJsonContent } from "./WithFetchJsonContent";

export const WithBannerData = ({ children }) => {
  const hasBannerData = useSelector(bannerDataSelector);

  return (
    <WithFetchJsonContent
      reduxInStore={hasBannerData}
      addToReduxFunction={addBannerData}
      jsonLocation="content/headerBanner"
      showLoading={false}
    >
      {children}
    </WithFetchJsonContent>
  );
};
